export default "__VITE_ASSET__CxA22e8C__"